// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxFilledSvg from "@fishx/icons-svg/es/asn/MedicineBoxFilled";
import FishxIcon from '../components/FishxIcon';

var MedicineBoxFilled = function MedicineBoxFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxFilledSvg
  }));
};

MedicineBoxFilled.displayName = 'MedicineBoxFilled';
export default React.forwardRef(MedicineBoxFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MedicineBoxFilled.js
// module id = 3098
// module chunks = 0